import { gql } from '@apollo/client'

export const GET_PAGED_HUBSPOT_SYNCHRONIZATION_LOGS_QUERY = gql`
  query getPagedHubSpotSynchronizationLogs(
    $after: String
    $before: String
    $first: Int
    $last: Int
    $order: [HubSpotSynchronizationLogSortInput!]
    $where: HubSpotSynchronizationLogFilterInput
  ) {
    hubSpotSynchronizationLogs(
      after: $after
      before: $before
      first: $first
      last: $last
      order: $order
      where: $where
    ) {
      edges {
        node {
          id
          onepointEntityName
          onepointEntityId
          hubSpotObjectName
          hubSpotObjectId
          isEnabled
          isSuccessful
          createdAt
          createdBy
          lastModifiedAt
          lastModifiedBy
          message
          rawResponse
          type
        }
      }
      totalCount
      pageInfo {
        startCursor
        endCursor
        hasPreviousPage
        hasNextPage
      }
    }
  }
`
